export default __webpack_public_path__ + "static/media/banner.b35d4fd0.png";